import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './oficiniavirtualproveedores.css';

const OficinaVirtualProveedores = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container transparencia-container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h1 className='title'>
            Oficina Virtual de <span className='text-wine'>Proveedores y</span> Contratistas
          </h1>
          <hr className='hr-gob'/>
        </div>

        <div className='col-md-6 col-12 oficina-column'>
          <Link to="/OficinaVirtualProveedor" className='oficina-link'>
            <img src="/assets/imgs/oficina_virtual/provedores.png" alt="Oficina Virtual de Proveedores" className='oficina-img' />
          </Link>
          <p className='oficina-text'>
            Si usted es <strong>Proveedor</strong> y desea realizar algún tramite favor de ingresar al siguiente link:
          </p>
          <Link to="/OficinaVirtualProveedor" className='btn-oficina'>
            Ingresar
          </Link>
        </div>

        <div className='col-md-6 col-12 oficina-column'>
          <Link to="/OficinaVirtualContratista" className='oficina-link'>
            <img src="/assets/imgs/oficina_virtual/oficina_contratista.png" alt="Oficina Virtual de Contratistas" className='oficina-img' />
          </Link>
          <p className='oficina-text'>
            Si usted es <strong>Contratista</strong> y desea realizar algún tramite favor de ingresar al siguiente link:
          </p>
          <Link to="/OficinaVirtualContratista" className='btn-oficina'>
            Ingresar
          </Link>
        </div>
      </div>
    </div>
  )
}

export default OficinaVirtualProveedores;
